import type { SVGProps } from "react";
export interface BooksIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BooksIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BooksIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.25 15.151a1.125 1.125 0 0 1 .506 2.193l-5.36 1.238-.112.019a1.125 1.125 0 0 1-.393-2.212zm-8.25.724.115.005a1.125 1.125 0 0 1 0 2.239l-.116.006H2a1.125 1.125 0 1 1 0-2.25zm6-10.467a1.125 1.125 0 0 1 .506 2.192l-5.358 1.238-.114.02a1.126 1.126 0 0 1-1.197-.732H2a1.126 1.126 0 0 1 0-2.25h11l.115.005c.413.042.757.307.916.673z"
      />
      <path
        fill={color}
        d="M.875 19V5A3.125 3.125 0 0 1 4 1.875h1.5c.76 0 1.457.273 1.999.725A3.1 3.1 0 0 1 9.5 1.875H11c.947 0 1.794.424 2.367 1.09.37-.315.817-.55 1.323-.667l1.462-.338.315-.056a3.125 3.125 0 0 1 3.432 2.398l3.15 13.64a3.126 3.126 0 0 1-2.034 3.662l-.308.087-1.461.337a3.125 3.125 0 0 1-3.749-2.34l-1.373-5.946V19A3.125 3.125 0 0 1 11 22.125H9.5a3.1 3.1 0 0 1-2.001-.725 3.1 3.1 0 0 1-2 .725H4A3.125 3.125 0 0 1 .876 19ZM16.657 4.153l-1.46.337a.876.876 0 0 0-.656 1.05l3.149 13.64a.875.875 0 0 0 1.049.657l1.462-.338.168-.058a.874.874 0 0 0 .488-.991l-3.15-13.64a.876.876 0 0 0-1.05-.657M3.125 19c0 .482.392.874.875.874h1.5A.876.876 0 0 0 6.375 19V5a.876.876 0 0 0-.875-.875H4A.875.875 0 0 0 3.125 5zm5.5 0c0 .482.392.874.875.874H11a.875.875 0 0 0 .874-.875V5A.875.875 0 0 0 11 4.125H9.5c-.423 0-.775.3-.857.699L8.625 5z"
      />
    </svg>
  );
}
